"use client";

import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Facebook, Instagram, Linkedin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4">
        <div className="h-5 w-16 bg-muted-light animate-pulse rounded-sm" />
        <div className="h-5 w-16 bg-muted-light animate-pulse rounded-sm" />
        <div className="h-5 w-16 bg-muted-light animate-pulse rounded-sm" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm font-medium text-secondary hover:text-primary-dark hover:font-semibold transition-all duration-[150ms]">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com/axionphysio",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://instagram.com/axionphysio",
    label: "Instagram"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com/company/axionphysio",
    label: "LinkedIn"
  }];
  return <footer id="footer" className="bg-background py-8 px-6 mt-[100px]">
      <div className="max-w-7xl mx-auto">
        {}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-6">
          {}
          <div className="flex-shrink-0">
            <Link to="/HomePage">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1537983/img/axion_physiotherapy_logo.png" alt="Axion Physiotherapy" className="h-7" />
            </Link>
          </div>

          {}
          <MenuProvider menu_id="4" className="flex-grow flex justify-center">
            <FooterMenuConsumer />
          </MenuProvider>

          {}
          <div className="flex items-center gap-4 flex-shrink-0">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={i} data-index={i} to={social.href} newTab className="text-secondary hover:text-primary-dark transition-colors duration-[150ms]" aria-label={social.label}>
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>
        </div>

        {}
        <Separator className="bg-secondary/20 mb-4" />

        {}
        <div className="text-center">
          <p className="text-sm text-muted">
            © {new Date().getFullYear()} Axion Physiotherapy. All rights reserved.
          </p>
          <p className="text-sm text-muted mt-1">
            Mondays - Saturdays 9am-5pm
          </p>
        </div>
      </div>
    </footer>;
}